import { Outlet } from "react-router-dom";
import useIdleLogout from "../hooks/useIdleLogout";

const AuthenticatedLayout = () => {
  useIdleLogout(60); // 1 hour idle time
  return <Outlet />;
};

export default AuthenticatedLayout;